import VisualPlan from 'app/frontend/types/custom/VisualPlan'
import { Badge } from '@/components/ui/badge'
import Card from 'app/frontend/base/components/Card'
import { cn } from '@/lib/utils'
import VisualCanvas from './visual_plans/VisualCanvas'

type Props = {
  visual: VisualPlan
  className?: string
  embedded?: boolean
}

const VisualPlanThumbnail = ({ visual, className, embedded }: Props) => {
  const firstScreen = visual.screens[0]
  const canvas = (
    <div
      className={cn(
        'relative w-full overflow-hidden rounded',
        embedded && className,
      )}
    >
      <VisualCanvas
        encounterId={visual.encounterId}
        imageIndex={firstScreen?.image_index ?? 0}
        shapes={firstScreen?.shapes ?? []}
        zoom={firstScreen?.zoom}
        showZoomOverview={false}
        zoomable={false}
        className='w-full overflow-hidden rounded'
      />
      {embedded ? (
        <Badge
          variant='outline'
          className='absolute bottom-1 right-1 shrink-0 bg-background/80'
        >
          {visual.screens.length}
        </Badge>
      ) : null}
    </div>
  )

  if (embedded) return canvas

  return (
    <Card
      className={cn('p-2 hover:border-primary transition-colors', className)}
    >
      <VisualCanvas
        encounterId={visual.encounterId}
        imageIndex={firstScreen?.image_index ?? 0}
        shapes={firstScreen?.shapes ?? []}
        zoom={firstScreen?.zoom}
        showZoomOverview={false}
        zoomable={false}
        className='w-full overflow-hidden rounded'
      />
      <div className='mt-1 flex items-center justify-between gap-1'>
        <div className='truncate text-sm font-medium'>{visual.name}</div>
        <Badge variant='outline' className='shrink-0'>
          {visual.screens.length}
        </Badge>
      </div>
    </Card>
  )
}

export default VisualPlanThumbnail
